import styled from 'styled-components';

export const Select = styled.select`
    border: ${props =>
        props.errormask ? '1px solid #c1272d' : '1px solid rgb(220, 220, 220)'};
    height: 22px;
    width: 100%;
    font-family: sans-serif;
    font-weight: bold;
    color: rgb(40, 40, 45);
    background-size: 15px auto !important;
    background: ${props =>
        props.errormask
            ? `url(${props.background}) no-repeat 95% 50%`
            : 'none'};
`;



// WEBPACK FOOTER //
// ./src/styledSystem/Select.js